const socialPlatforms = [
    { name: 'YouTube', icon: 'youtube', url: 'https://youtube.com/@darktr0jan' },
    { name: 'Instagram', icon: 'instagram', url: 'https://www.instagram.com/dark.tr0jan?igsh=M3Aya2V1bTduOG4y' },
    { name: 'Facebook', icon: 'facebook', url: 'https://www.facebook.com/profile.php?id=61581159777836' },
    { name: 'Twitch', icon: 'twitch', url: 'https://twitch.tv/darktr0jan' },
    { name: 'Song List', icon: 'music', url: 'https://www.streamersonglist.com/t/darktr0jan/songs' },
];

const iconPaths = {
    youtube: 'M10 15l5.19-3L10 9v6m11.56-7.83c.13.47.22 1.1.28 1.9.07.8.1 1.49.1 2.09L22 12c0 2.19-.16 3.8-.44 4.83-.25.9-.83 1.48-1.73 1.73-.47.13-1.33.22-2.65.28-1.3.07-2.49.1-3.59.1L12 19c-4.19 0-6.8-.16-7.83-.44-.9-.25-1.48-.83-1.73-1.73-.13-.47-.22-1.1-.28-1.9-.07-.8-.1-1.49-.1-2.09L2 12c0-2.19.16-3.8.44-4.83.25-.9.83-1.48 1.73-1.73.47-.13 1.33-.22 2.65-.28 1.3-.07 2.49-.1 3.59-.1L12 5c4.19 0 6.8.16 7.83.44.9.25 1.48.83 1.73 1.73z',
    instagram: 'M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8 1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5 5 5 0 0 1-5 5 5 5 0 0 1-5-5 5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3z',
    facebook: 'M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z',
    twitch: 'M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L20.57 13.714V0zm13.714 13.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h12.857Z',
    'x-twitter': 'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z',
    music: 'M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z',
};

export default function SocialLinks({ size = 'default' }: { size?: 'default' | 'small' }) {
    const iconSize = size === 'small' ? 'w-5 h-5' : 'w-6 h-6';
    const buttonSize = size === 'small' ? 'w-10 h-10' : 'w-12 h-12';

    return (
        <div className="flex items-center justify-center gap-4">
            {socialPlatforms.map((platform) => (
                <a
                    key={platform.name}
                    href={platform.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`social-icon ${buttonSize}`}
                    aria-label={platform.name}
                >
                    <svg className={iconSize} fill="currentColor" viewBox="0 0 24 24">
                        <path d={iconPaths[platform.icon as keyof typeof iconPaths]} />
                    </svg>
                </a>
            ))}
        </div>
    );
}
